import finance from "@/assets/svg/finance.svg";
export default {
    path: "/reconciliation",
    redirect: "/reconciliation/index",
    meta: {
      icon: finance,
      title: "对账管理",
      rank: 4,
      roles: ["finance"]
    },
    children: [
      {
        path: "/reconciliation/index",
        name: "customerSummary",
        component: () => import("@/views/reconciliation/customerSummary/index.vue"),
        meta: {
          title: "客户汇总",
          keepAlive: true,
          roles: ["finance_summary"]
        }
      },
      {
        path: "/reconciliation/reconciliationList",
        name: "reconciliationList",
        component: () => import("@/views/reconciliation/reconciliationList/index.vue"),
        meta: {
          title: "账单列表",
          keepAlive: true,
          roles: ["finance_bill"]
        }
      }
    ]
  } as RouteConfigsTable;